export enum DASHBOARD_DOC_IN_VIEW_NAME {
  DASHBOARD_DOC_IN = "DASHBOARD_DOC_IN",
  DASHOARD_DOC_IN_LIST = "DASHOARD_DOC_IN_LIST",
  DASHBOARD_DOC_IN_DETAIL = "DASHBOARD_DOC_IN_DETAIL"
}